import { VoiceNoteData, VoiceNoteService, WavesurferData } from './services/voice-note.service';
import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter, OnDestroy, ChangeDetectorRef,
} from '@angular/core';
import {interval, Observable, Subscription, timer} from 'rxjs';
import { fromEvent } from 'rxjs';
import {debounce, delay, take, tap} from "rxjs/operators";
import { NgTemplateOutlet, NgClass } from '@angular/common';
import { ReadReceiptComponent } from '../read-receipt/read-receipt.component';

const PLAY = '../../../../../assets/svg/Play.svg';
const PAUSE = '../../../../../assets/svg/Pause.svg';
const SYSTEM = '#2cc4ec';
const USER = '#8cc63f';

@Component({
    selector: 'app-voice-note',
    templateUrl: './voice-note.component.html',
    styleUrls: ['./voice-note.component.scss'],
    imports: [NgTemplateOutlet, NgClass, ReadReceiptComponent]
})
export class VoiceNoteComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() messageSource: Boolean;
  @Input() recording = false;
  @Input() wavesurferData: WavesurferData;
  @Input() content: any;

  @Output() cancelClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() sendClick: EventEmitter<VoiceNoteData> = new EventEmitter<VoiceNoteData>();

  permissionValue: Observable<Boolean>;

  @Input()
  get permission() {
    return this.permissionValue;
  }

  @Output() permissionChange: EventEmitter<Observable<Boolean>> = new EventEmitter<
    Observable<Boolean>
  >();

  set permission(permission: Observable<Boolean>) {
    this.permissionValue = permission;
    this.permissionChange.emit(permission);
  }

  @ViewChild('wave') waveElement: ElementRef;
  @ViewChild('playBtnImg') playBtnImg: ElementRef;
  @ViewChild('sendButton') sendBtnElement: ElementRef;

  voiceNoteService: VoiceNoteService;

  timeInterval = interval(1000);
  sendBtnClickEvent: Subscription;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {}

  ngOnDestroy(): void {
    this.sendBtnClickEvent?.unsubscribe();
  }

  ngAfterViewInit() {
    const data: WavesurferData = {
      container: this.waveElement.nativeElement,
      waveColor: this.messageColor(),
      ...this.wavesurferData,
    };
    this.voiceNoteService = new VoiceNoteService(data, this.recording, this.cdr);

    if (!this.recording && this.content) {
      this.voiceNoteService.download(this.content['src']);
    }

    this.permission = this.voiceNoteService.getPermissionData;

    this.voiceNoteService.wavesurfer.on('finish', () => {
      this.voiceNoteService.state = 'playing';
      this.setIcon();
      this.voiceNoteService.wavesurfer.stop();
      this.cdr.markForCheck();
    });

    this.voiceNoteService.wavesurfer.on('audioprocess', () => {
      this.cdr.markForCheck();
    });

    if (this.voiceNoteService.getPermissionData) {
      this.sendBtnClickEvent = fromEvent(this.sendBtnElement.nativeElement, 'click')
          .pipe(
              debounce(() => timer(200)),
              take(1),
              tap(() => this.voiceNoteService.stopRecording()),
              delay(200),
              tap(() => this.sendClick.emit(this.voiceNoteService.voiceNotData))
          )
          .subscribe();
    }
  }

  messageColor() {
    return this.messageSource ? USER : SYSTEM;
  }

  download(e) {
    const file = e.target.files[0];
    const url = URL.createObjectURL(file);
    this.voiceNoteService.download(url);
  }

  playState() {
    this.timeInterval.subscribe(() => {
      if (this.voiceNoteService.state === 'inactive') {
        this.playBtnImg.nativeElement.setAttribute('src', PLAY);
      }
    });
  }

  onPlay() {
    this.setIcon();
    switch (this.voiceNoteService.voiceNoteState.state) {
      case 'inactive':
      case 'paused':
        this.voiceNoteService.play();
        break;
      case 'playing':
        this.voiceNoteService.pause();
        break;
      default:
        break;
    }
  }

  public cancelBtn() {
    this.voiceNoteService.stopRecording();
    this.voiceNoteService.clear();
    this.cancelClick.emit();
  }

  private setIcon() {
    switch (this.voiceNoteService.voiceNoteState.state) {
      case 'inactive':
      case 'paused':
        this.playBtnImg.nativeElement.setAttribute('src', PAUSE);
        return;
      case 'playing':
        this.playBtnImg.nativeElement.setAttribute('src', PLAY);
        return;
    }
  }
}
